import axiosInstance from './axios';
import PaginationData from 'types/models/PaginationData';
import joinURLParams from 'utils/joinUrlParams';

export type ConfigType = 'bool' | 'int' | 'str';
export interface SystemConfigItem {
  id: number;
  key: string;
  value: string;
  type: ConfigType;
  desc: string;
}

export const getSystemConfig = async (
  page?: number,
  searchTerm?: string,
): Promise<PaginationData<SystemConfigItem>> => {
  try {
    const url = joinURLParams({ page: page ?? 1, searchTerm }, 'system-config');
    const { data: paginationData } = await axiosInstance({
      method: 'get',
      url,
    });
    return {
      currentPage: paginationData.current_page,
      data: paginationData.data,
      perPage: paginationData.per_page,
      total: paginationData.total,
    };
  } catch (error) {
    throw error;
  }
};

export const updateSystemConfig = async (payload: SystemConfigItem): Promise<SystemConfigItem> => {
  try {
    const { data } = await axiosInstance({
      method: 'put',
      url: 'system-config',
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
